import React, {FunctionComponent} from 'react'
import { IProps } from './IProps'

// tslint:disable-next-line:variable-name
export const Number: FunctionComponent<IProps> = ({
    as: Tag = 'span',
    style = 'decimal',
    currency = 'EUR',
    children,
    ...props
}) => {
    if (isNaN(children as number) || typeof children !== 'number') {
        return null
    }

    const formatOptions = {
        style,
        currency,
        ...props
    }

    const formattedNumber = new Intl.NumberFormat('nl-BE', formatOptions).format(children)

    // @ts-ignore
    return <Tag>{formattedNumber}</Tag>
}
